import { useMemo } from "react";

const useAdditionalData = (dynamicCards, initialCards = [], customTabs = []) => {

    return useMemo(() => {
        const hospitalCardsArr = (initialCards || []).map(ele => ({ ...ele, isDefaultCard: true }));
        dynamicCards?.forEach((ele) => {
            hospitalCardsArr.push({
                value: ele?.accessor,
                label: ele?.tableLabel || ele?.label,
                tooltipContent: ele?.description || ele?.aiDescription || ele?.tableLabel || ele?.label,
                timeRangeType: ele?.timeRangeType,
                aiDescription: ele?.aiDescription,
                description: ele?.description,
                title: ele?.tableLabel || ele?.label,
                existingAccessor: ele?.existingAccessor ?? null,
                _id: ele?._id ? String(ele._id) : null,
                shareCount: ele?.shareCount,
                isUniversalAccess: ele?.isUniversalAccess,
                isUniversal: ele?.isUniversal,
                isShared: ele?.isShared,
                isCustomShare: ele?.isCustomShare,
                shareInfo: ele?.shareInfo,
                sharedBy: ele?.sharedBy,
                sharedByName: ele?.sharedByName,
                shareId: ele?.shareId,
                userId: ele?.userId,
                isDefaultCard: true,
            });
        });

        if (customTabs?.length > 0) {
            customTabs.forEach((ele) => {
                hospitalCardsArr.push({
                    value: ele?.accessor,
                    label: ele?.title ?? ele?.label,
                    tooltipContent: ele?.description || ele?.aiDescription || ele?.label || ele?.tableLabel,
                    isCustomTab: true,
                    type: ele?.type,
                    userId: ele?.userId,
                    _id: ele?._id ? String(ele?._id) : null,
                    timeRangeType: ele?.timeRangeType,
                    shareCount: ele?.shareCount,
                    isUniversalAccess: ele?.isUniversalAccess,
                    isUniversal: ele?.isUniversal,
                    isShared: ele?.isShared,
                    isCustomShare: ele?.isCustomShare,
                    shareInfo: ele?.shareInfo,
                    sharedBy: ele?.sharedBy,
                    sharedByName: ele?.sharedByName,
                    newTitle: ele?.title ?? null,
                    shareId: ele?.shareId,
                    isHidden: ele?.isHidden,
                    dateAnalysisStartQuestion: ele?.dateAnalysisStartQuestion,
                    dateAnalysisEndQuestion: ele?.dateAnalysisEndQuestion,
                    aiDescription: ele?.aiDescription,
                    description: ele?.description,
                    title: ele?.title ?? ele?.label,
                    existingAccessor: ele?.existingAccessor ?? null,
                    isDefaultCard: true,
                });
            });
        }
        return hospitalCardsArr;
    }, [customTabs, dynamicCards, initialCards]);
};

export default useAdditionalData;
